module.exports = __webpack_public_path__ + "img/Peng_Wang@2x.a6d74030.png";